import React from 'react';

const SGDSMasthead = () => {
  const showMastHead = true;
  window.location.hostname?.toLowerCase()?.endsWith('.gov.sg');
  return showMastHead && <sgds-masthead></sgds-masthead>;
};

export default SGDSMasthead;
